<template>
  <v-snackbar :value="visible" top :timeout="0" multi-line>
    <v-icon v-if="icon" dark left dense>{{ icon }}</v-icon>
    {{ text }}
    <v-btn v-if="accept" @click="accept">Godkänn</v-btn>
    <v-btn v-if="deny" @click="deny">Neka</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      custom_icon: null,
      text: "",
      accept: null,
      deny: null
    };
  },
  watch: {
    current(snack) {
      if (!snack) {
        this.visible = false;
        return;
      }

      this.text = snack.text;
      this.custom_icon = snack.icon;
      this.accept = snack.accept;
      this.deny = snack.deny;
      this.visible = true;
    }
  },
  computed: {
    current() {
      return this.$store.getters["snackbar/queue"][0];
    },
    icon() {
      return this.custom_icon || "mdi-information";
    }
  }
};
</script>
